import { LoadingScreen } from "@waldner-laboreinrichtungen/component-system";
import type { FC } from "react";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { useAuthContext } from "../auth-provider";

export const CallbackPage: FC = () => {
  const auth = useAuthContext();
  const navigate = useNavigate();

  useEffect(() => {
    // After successful login, redirect to home
    if (auth.isAuthenticated) {
      navigate("/", { replace: true });
    }
  }, [auth.isAuthenticated, navigate]);

  // Show loading while processing callback
  return <LoadingScreen loadingText="Anmeldung..." />;
};
